import React, { useEffect } from "react";
import { toast } from "react-toastify";

import {
  IPaymentMethod,
  useAddPaymentMethodMutation,
  useUpdatePaymentMethodMutation,
} from "../../../../services/BillingService";
import { getLinkedFirm } from "../../../../sessionStorage/sessionStorage";
import { SettingsFormInput } from "../../components/SettingsFormInput";

type Props = {
  paymentMethod?: IPaymentMethod;
  onClose: () => void;
  onSuccess: () => void;
};

export const PaymentMethodForm: React.FC<Props> = ({
  paymentMethod,
  onClose,
  onSuccess,
}) => {
  const defaultValue = paymentMethod?.paymentMethod || "";

  const [
    updatePaymentMethod,
    {
      isLoading: isLoadingUpdate,
      isSuccess: isSuccessUpdate,
      isError: isErrorUpdate,
    },
  ] = useUpdatePaymentMethodMutation();
  const [
    addPaymentMethod,
    { isLoading: isLoadingAdd, isSuccess: isSuccessAdd, isError: isErrorAdd },
  ] = useAddPaymentMethodMutation();

  const onSubmit = async (value: string) => {
    if (!value.trim()) {
      return;
    }

    if (paymentMethod) {
      await updatePaymentMethod({
        id: paymentMethod?.id || "",
        paymentMethod: value,
      });
    } else {
      await addPaymentMethod({
        paymentMethod: value,
        orgId: getLinkedFirm()?.orgId,
      });
    }
  };

  useEffect(() => {
    if (isSuccessUpdate) {
      toast("Payment method successfully Updated", {
        type: "success",
      });
      onSuccess();
      onClose();
    }
  }, [isSuccessUpdate]);

  useEffect(() => {
    if (isSuccessAdd) {
      toast("Payment method successfully Created", {
        type: "success",
      });
      onSuccess();
      onClose();
    }
  }, [isSuccessAdd]);

  useEffect(() => {
    if (isErrorUpdate || isErrorAdd) {
      toast("Something went wrong", {
        type: "error",
      });
    }
  }, [isErrorUpdate, isErrorAdd]);

  return (
    <SettingsFormInput
      onSave={onSubmit}
      onCancel={onClose}
      isLoading={isLoadingUpdate || isLoadingAdd}
      defaultValue={defaultValue}
      placeholder={"Type payment method..."}
    />
  );
};
